"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var import_platform = require("@hcengineering/platform");
var import_text_editor = __toESM(require("@hcengineering/text-editor"));
const icons = require("../assets/icons.svg");
(0, import_platform.loadMetadata)(import_text_editor.default.icon, {
  Header1: `${icons}#header1`,
  Header2: `${icons}#header2`,
  Header3: `${icons}#header3`,
  Underline: `${icons}#underline`,
  Strikethrough: `${icons}#strikethrough`,
  Bold: `${icons}#bold`,
  Italic: `${icons}#italic`,
  Link: `${icons}#link`,
  ListNumber: `${icons}#listNumber`,
  ListBullet: `${icons}#listBullet`,
  ListTodo: `${icons}#listTodo`,
  Quote: `${icons}#quote`,
  Code: `${icons}#code`,
  CodeBlock: `${icons}#codeBlock`,
  TableProps: `${icons}#tableProps`,
  AlignLeft: `${icons}#alignLeft`,
  AlignCenter: `${icons}#alignCenter`,
  AlignRight: `${icons}#alignRight`,
  MoreH: `${icons}#moreH`,
  Expand: `${icons}#expand`,
  ScaleOut: `${icons}#scaleOut`,
  Download: `${icons}#download`,
  Note: `${icons}#note`,
  Comment: `${icons}#comment`,
  SelectTable: `${icons}#move`,
  MergeCells: `${icons}#union`,
  SplitCells: `${icons}#divide`,
  Brush: `${icons}#brush`,
  Highlight: `${icons}#highlight`,
  Subscript: `${icons}#subscript`,
  Superscript: `${icons}#superscript`,
  Mathematics: `${icons}#mathematics`,
  MathematicsBlock: `${icons}#mathematicsBlock`,
  TextStyle: `${icons}#textStyle`,
  LinkPreview: `${icons}#link`,
  Refresh: `${icons}#refresh`,
  ShowDiff: `${icons}#showDiff`,
  SeeOriginalData: `${icons}#seeOriginal`,
  EmbedPreview: `${icons}#linkEmbed`
});
//# sourceMappingURL=index.js.map
